// ============ بيانات المقالات المشتركة بين كل اللغات ============
// العنوان والملخص لكل مقال موجودين في ملف اللغة (t.blogs.items) بنفس الترتيب.
// التاريخ بيتكتب هنا مرة واحدة وبيتعرض بصيغة كل لغة تلقائيًا.
export const BLOG_META = [
  { date: "2026-10-03", minutes: 7, cat: "investing" },
  { date: "2026-09-24", minutes: 5, cat: "guides" },
  { date: "2026-09-11", minutes: 6, cat: "market" },
  { date: "2026-08-29", minutes: 8, cat: "buying" },
  { date: "2026-08-15", minutes: 6, cat: "buying" },
  { date: "2026-08-02", minutes: 5, cat: "guides" },
  { date: "2026-07-19", minutes: 7, cat: "investing" },
  { date: "2026-07-05", minutes: 6, cat: "finance" },
  { date: "2026-06-21", minutes: 5, cat: "market" },
  { date: "2026-06-08", minutes: 6, cat: "investing" },
];

// المقالات بالنص المترجم + التاريخ المنسّق
export const blogItems = (t, locale) =>
  BLOG_META.map((m, i) => {
    const text = (t.blogs.items && t.blogs.items[i]) || {};
    return {
      ...m,
      idx: i,
      title: text.title || "",
      excerpt: text.excerpt || "",
      category: (t.blogs.categories && t.blogs.categories[m.cat]) || m.cat,
      dateLabel: new Intl.DateTimeFormat(locale, { day: "numeric", month: "short", year: "numeric", timeZone: "UTC" }).format(
        new Date(`${m.date}T00:00:00Z`)
      ),
    };
  });
